import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type StudentEventsService from 'district-ui-client/services/student-events'
import { toStatsScope, type StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type UiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'

export default class ReSpellingProgressTotalsRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, period, scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<UiScopeRoute>

    const statsScope = toStatsScope(uiScope)

    const product: LegacyProductRe = 're'
    const precinct: LegacyPrecinctSpelling = 'spelling'
    const stats = await this.makeStatsRequest(product, precinct, statsScope, period)

    return {
      product,
      uiScope,
      period,
      scopedData,
      precinct,
      ...stats,
    }
  }

  makeStatsRequest = (
    product: LegacyProductRe,
    precinct: LegacyPrecinctSpelling,
    scope: StatsScope,
    period: NormalizedInterval,
  ) => {
    const { studentEvents } = this

    return RSVP.hash({
      spellingProgressTotals: studentEvents.courseProgressTotals(product, precinct, scope, period),
    })
  }
}
